/* ──────────────────────────────────────────────────────────────────────────
 * TRD series: Third‑party / JWeb runtime errors
 * ────────────────────────────────────────────────────────────────────────── */
export const THIRD_PARTY_ERROR_CODES = {
  JWEB_AUTH_PLUGIN_UNAVAILABLE: 'CLIENTOS_TRD_001',
  JWEB_AUTH_PLUGIN_RUNTIME_ERROR: 'CLIENTOS_TRD_002',
  JWEB_DEVICE_INFO_ERROR: 'CLIENTOS_TRD_003',
  VALUE_STORE_WRITE_FAILED: 'CLIENTOS_TRD_004',
  VALUE_STORE_READ_FAILED: 'CLIENTOS_TRD_007',
  JWEB_CONTAINER_INFO_ERROR: 'CLIENTOS_TRD_008',
  JWEB_SERVICE_ROUTING_ERROR: 'CLIENTOS_TRD_009'
} as const;
